<template>

  <rate-calendar-bar
    :calendar-type="calendarType"
    :title="title"
    icon="$spotRate"
    is-exception
  >

    <template v-slot:extras>
      <p>{{ costRange }}</p>
    </template>

  </rate-calendar-bar>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import RateCalendarBar from './RateCalendarBar.vue'
import type { NonEventExceptionItem } from '../types'
import { currencyFormatter } from '../../../../../utils/formatters'

interface Props {
  item: NonEventExceptionItem
  calendarType: string
}

const props = defineProps<Props>()

const title = computed<string>(() => {

  if (props.calendarType === 'month') {
    return `${productName.value} ${costRange.value}`
  } else {
    return productName.value
  }

})

const productName = computed<string>(() => {
  return props.item.locationProduct?.product?.name ?? '(unknown product)'
})

const costs = computed<number[]>(() => {

  const output: number[] = []

  props.item.defaultRates.forEach(dr => {

    dr.channelDefaultRates.forEach(cdr => {
      const sr = props.item.spotRates.find(sr => sr.defaultRateID === dr.ID && sr.channelFacilityID === cdr.channelFacilitiesID)
      output.push(sr?.spotCost ?? cdr.channelCost)
    })

  })

  return output.toSorted((a, b) => a - b)

})

const costRange = computed<string>(() => {

  const lowestCost = costs.value.at(0) ?? null
  const highestCost = costs.value.at(-1) ?? null

  if (lowestCost === null || highestCost === null) {
    return ''
  } else if (lowestCost === highestCost) {
    return currencyFormatter.format(lowestCost)
  } else {
    return `${currencyFormatter.format(lowestCost)} – ${currencyFormatter.format(highestCost)}`
  }

})

</script>
